import { IAuthData } from '../types';

// 下划线转驼峰
export const underscoreToCamelCase = (obj: any) => {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }

  return Object.keys(obj).reduce(
    (newObj, key) => {
      const newKey = key.replace(/(_\w)/g, (m) => m[1].toUpperCase());
      (newObj as any)[newKey] = underscoreToCamelCase(obj[key]);
      return newObj;
    },
    Array.isArray(obj) ? [] : {}
  );
};

// 驼峰转下划线
export const camelCaseToUnderscore = (obj: any) => {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }

  return Object.keys(obj).reduce(
    (newObj, key) => {
      // 在每个大写字母前添加下划线，并转换为小写，但排除字符串的第一个字符
      const newKey = key
        .split('')
        .map((char, index) =>
          char.toUpperCase() === char && index !== 0 ? `_${char.toLowerCase()}` : char.toLowerCase()
        )
        .join('');
      (newObj as any)[newKey] = camelCaseToUnderscore(obj[key]);
      return newObj;
    },
    Array.isArray(obj) ? [] : {}
  );
};

const parseStr = (rawValue: string) => {
  let value;
  if (!isNaN(Number(rawValue)) && rawValue !== '') {
    value = Number(rawValue);
  } else if (rawValue === 'true') {
    value = true;
  } else if (rawValue === 'false') {
    value = false;
  } else if (rawValue === 'null') {
    value = null;
  } else if (rawValue === 'undefined') {
    value = undefined;
  } else if (!isNaN(Date.parse(rawValue))) {
    value = new Date(rawValue);
  } else {
    try {
      value = decodeURIComponent(rawValue);
    } catch (e) {
      console.error('parseStr error', e);
      value = rawValue;
    }
  }
  return value;
};

// cookie 字符串/对象的值转为原类型
export const parseCookie = (input: string | { [key: string]: any }): { [key: string]: any } => {
  const cookies: { [key: string]: any } = {};
  try {
    if (typeof input === 'string') {
      input.split('; ').forEach((cookie) => {
        const [key, value] = cookie.split('=');
        cookies[decodeURIComponent(key)] = parseStr(value);
      });
      return cookies;
    }
    for (const key in input) {
      cookies[key] = parseStr(input[key]);
    }
    return cookies;
  } catch (e) {
    console.error('==== parseCookie', input, e);
    return {};
  }
};

export const stringifyCookie = (obj: { [key: string]: any }) => {
  try {
    return Object.entries(obj)
      .map(([key, value]) => `${encodeURIComponent(key)}=${JSON.stringify(value)}; path=/`)
      .join('; ');
  } catch (e) {
    console.error('stringifyCookie error: %o', e);
    return '';
  }
};

export const getAuthDataFromNextContext = (headers: any) => {
  const authData = underscoreToCamelCase(JSON.parse((headers['x-auth-data'] as string) || '{}'));
  authData.isNew = authData.isNew !== 'false';
  authData.isAnonymous = authData.isAnonymous !== 'false';

  authData.userId = Number(authData.userId);
  authData.deviceId = Number(authData.deviceId);
  authData.uniqueId = Number(authData.uniqueId);

  return authData as IAuthData;
};

export const extractLangFromUrl = (url: string) => {};

export const extractQueryParamsFromUrl = (url?: string) => {
  if (!url) return;
  const query = url.split('?').pop();
  if (query) {
    try {
      return new URLSearchParams(query);
    } catch {
      //
    }
  }
};
